var map = {
	"./24hrs.svg": "3b9a",
	"./account.svg": "0acb",
	"./add.svg": "8b65",
	"./angle-down.svg": "92e6",
	"./angle-right.svg": "3c56",
	"./archive.svg": "6d9b",
	"./arr-back.svg": "985f",
	"./arr-scroll.svg": "f81f",
	"./arrow-download.svg": "8311",
	"./arrow-orange.svg": "5673",
	"./arrow.svg": "315f",
	"./arrows-crossed.svg": "c271",
	"./arrows-locked.svg": "f291",
	"./at.svg": "f6f2",
	"./attach-attach.svg": "3dda",
	"./attach-detach.svg": "d4d6",
	"./attached.svg": "1cfa",
	"./attention.svg": "28bc",
	"./author.svg": "7445",
	"./background.svg": "2a95",
	"./bell.svg": "4bf1",
	"./bell2.svg": "bb50",
	"./bell3.svg": "5b0b",
	"./blockquote.svg": "4bd7",
	"./bold.svg": "18b7",
	"./bookmarks.svg": "3272",
	"./bookmarks2.svg": "b5ea",
	"./btn-add.svg": "ba9d",
	"./calendar-alt.svg": "8fa9",
	"./calendar.svg": "276b",
	"./cash-blue.svg": "0d2d",
	"./cash-bordered.svg": "4f06",
	"./change.svg": "f591",
	"./chart-orange.svg": "01eb",
	"./check-bordered.svg": "ad09",
	"./check-green.svg": "46ab",
	"./check-list.svg": "9e4f",
	"./check.svg": "6561",
	"./checked-cross.svg": "7d60",
	"./checked-false.svg": "525f",
	"./checked-true-sm.svg": "3159",
	"./checked-true.svg": "054e",
	"./checked.svg": "c3e8",
	"./clock-bordered.svg": "d47b",
	"./close-circle.svg": "88fc",
	"./close-green.svg": "42d8",
	"./close-red.svg": "e382",
	"./close.svg": "58a4",
	"./close2.svg": "2eb2",
	"./close3.svg": "9b88",
	"./code.svg": "84e7",
	"./comments.svg": "8907",
	"./companies.svg": "287e",
	"./complete.svg": "0f01",
	"./contractor.svg": "67d0",
	"./copy.svg": "5e82",
	"./cost.svg": "caf1",
	"./cross.svg": "4860",
	"./crown.svg": "be99",
	"./customer.svg": "da94",
	"./danger.svg": "fc61",
	"./decorate.svg": "85b1",
	"./decorate2.svg": "0431",
	"./delete-white-sm.svg": "5d4a",
	"./delete.svg": "4edd",
	"./deleting.svg": "855a",
	"./down.svg": "ef8e",
	"./download.svg": "22b4",
	"./drag-handle.svg": "7e55",
	"./edit-alt-1.svg": "f976",
	"./edit-alt-2.svg": "4e0c",
	"./edit-alt-3.svg": "946a",
	"./edit-alt.svg": "27d4",
	"./edit.svg": "582c",
	"./edit2.svg": "32c3",
	"./edit3.svg": "3782",
	"./error-delete.svg": "7b23",
	"./exit.svg": "2c82",
	"./expand.svg": "4e51",
	"./expand2.svg": "9384",
	"./eye-closed.svg": "8ef2",
	"./eye-opened.svg": "d28d",
	"./facebook.svg": "34ad",
	"./file.svg": "15ca",
	"./files.svg": "483d",
	"./filter.svg": "a1d2",
	"./finish.svg": "73e6",
	"./folder-open-white.svg": "d95f",
	"./folder-open.svg": "524b",
	"./folders.svg": "4441",
	"./gantt.svg": "44a8",
	"./google.svg": "b8f9",
	"./home.svg": "dfed",
	"./icon-btn-green.svg": "5e03",
	"./infinity.svg": "2cbe",
	"./instagram.svg": "c1c5",
	"./italic.svg": "2054",
	"./link.svg": "e8f6",
	"./list-ol.svg": "55d4",
	"./list-ol2.svg": "bbe0",
	"./list-ul.svg": "24a9",
	"./loader.svg": "9f35",
	"./logo-new-year.svg": "d86f",
	"./logo-vertical.svg": "0076",
	"./logo.svg": "1ea0",
	"./magnifier.svg": "2443",
	"./mail.svg": "0cc2",
	"./manager.svg": "9a4c",
	"./map.svg": "38f6",
	"./member.svg": "f712",
	"./members.svg": "6f66",
	"./mobile-close.svg": "0b34",
	"./more.svg": "d9cb",
	"./new-contact.svg": "0a5f",
	"./new.svg": "20c5",
	"./no-avatar-project.svg": "014d",
	"./no-avatar.svg": "b9aa",
	"./no-image.svg": "6a58",
	"./no-materials.svg": "b300",
	"./no-sound.svg": "af46",
	"./notebook.svg": "3545",
	"./notification-check.svg": "7012",
	"./notification-comment.svg": "fa52",
	"./notification-lightning.svg": "c2fb",
	"./notification-play.svg": "bfd7",
	"./notifications.svg": "0702",
	"./notifications2.svg": "7993",
	"./open.svg": "7e24",
	"./parameters.svg": "56cc",
	"./percents-bordered.svg": "00ba",
	"./phone.svg": "7b69",
	"./play-button.svg": "3567",
	"./plus-colorless.svg": "9e4ff",
	"./plus.svg": "7aa7",
	"./plus2.svg": "a0d8",
	"./price.svg": "080c",
	"./profile.svg": "3975",
	"./project.svg": "9c8d",
	"./projects.svg": "8e6e",
	"./purse.svg": "0dce",
	"./question-circle-thin.svg": "717b",
	"./question-circle.svg": "0c07",
	"./question.svg": "7fcd",
	"./reference.svg": "c60d",
	"./rename.svg": "1fa5",
	"./reply.svg": "2b76",
	"./room.svg": "9a6d",
	"./round-app.svg": "fc49",
	"./rub.svg": "51f6",
	"./rule.svg": "2046",
	"./search.svg": "c6a2",
	"./send.svg": "5977",
	"./setting.svg": "1d1a",
	"./settings.svg": "53df",
	"./share.svg": "40eb",
	"./sky-banner.svg": "1ab1",
	"./skype.svg": "9c5e",
	"./slider-disabled.svg": "8477",
	"./slider-enabled.svg": "4eb5",
	"./sort-active.svg": "ccdf",
	"./sort.svg": "098d",
	"./square-dotted.svg": "8305",
	"./square-lined.svg": "f192",
	"./square.svg": "360e",
	"./square2.svg": "b28f",
	"./start.svg": "6796",
	"./stats/chart.svg": "c004",
	"./stats/check.svg": "8247",
	"./stats/clock.svg": "730a",
	"./stats/cross.svg": "77b5",
	"./successful.svg": "61b7",
	"./support.svg": "02cf",
	"./support2.svg": "522f",
	"./swap.svg": "49d2",
	"./tariff-like.svg": "3a41",
	"./tariffs.svg": "3100",
	"./task-view/hide-closed-tasks.svg": "1f4e",
	"./task-view/hide-noDate-tasks.svg": "5ccc",
	"./task-view/hide-projects.svg": "9cd6",
	"./tasks.svg": "e22c",
	"./telegram.svg": "ebde",
	"./trash.svg": "47b8",
	"./triangle.svg": "bc16",
	"./unchecked.svg": "11fc",
	"./underline.svg": "bef9",
	"./upload-dropzone.svg": "e9f8",
	"./upload-green.svg": "9ddd",
	"./upload-white-sm.svg": "5306",
	"./upload.svg": "5474",
	"./uploading.svg": "975f",
	"./user-check.svg": "1a82",
	"./user-plus.svg": "2773",
	"./user-small.svg": "6464",
	"./user.svg": "be92",
	"./vk.svg": "14a2",
	"./waiting.svg": "17cc",
	"./wallet.svg": "cd68",
	"./whatsapp.svg": "0bb3",
	"./zoom-in.svg": "5895",
	"./zoom-out.svg": "1c7e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57ae";